
import { ProjectService } from '../../../services/project.service';
import { Component, Input, SimpleChanges, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { Project, ProjectStatsConfiguration } from '../../../interfaces/project';
import { ProjectKpiService, KPICalculation, KPICalculationResult } from '../../../services/project-kpi.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
	selector: 'bb-kpi-performance',
	templateUrl: './bb-kpi-performance.component.html',
	styleUrls: ['./bb-kpi-performance.component.scss']
})
export class BbKpiPerformanceComponent implements OnInit, OnChanges, OnDestroy {
	@Input() project: Project;
	@Input() isLoading: boolean;
	@Input() configuration: ProjectStatsConfiguration;
	@Input() mode?: 'sidebar';

	selectedKPI: KPICalculation;
	showAllKpis = true;
	kpis: KPICalculation[];

	private subscriptions = new Subscription();

	constructor(
		protected projectKpiService: ProjectKpiService,
		protected router: Router,
		private projectService: ProjectService
	) {
	}

	ngOnInit() {
		this.subscriptions.add(this.projectKpiService.kpiSelectionSubject.subscribe((selectedKPI: KPICalculation) => {
			const kpiIds = this.project && this.project.kpiCalculations && this.project.kpiCalculations.map((k: KPICalculation) => k.id);
			if (kpiIds && kpiIds.indexOf(selectedKPI.id) !== -1 &&
				(!this.selectedKPI || !this.selectedKPI.id || this.selectedKPI.id !== selectedKPI.id)
			) {
				this.selectedKPI = selectedKPI;
			}
		}));

		if (this.isLoading === undefined) {
			this.isLoading = true;
		}

		this.subscriptions.add(this.projectService.projectWithStatsSubject.subscribe((projectWithStats: Project) => {
			if (projectWithStats && this.project && this.project.id === projectWithStats.id) {
				// this.projectWithStats = projectWithStats;
				if (this.mode === 'sidebar') {
					this.isLoading = false;
				}
			} else {
				// this.projectWithStats = null;
			}
		}));
		if (this.mode === 'sidebar') {
			this.checkShowAllKpis();
		}
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	checkShowAllKpis() {
		if (this.mode === 'sidebar' && this.project && this.project.kpiCalculations && this.project.kpiCalculations.length) {
			let importantKpis = [];
			importantKpis = this.project.kpiCalculations.filter((kpi: KPICalculation) => kpi.isImportant);
			if (importantKpis.length === 0) {
				this.showAllKpis = true;
			} else {
				this.showAllKpis = false;
			}
		}
	}

	ngOnChanges(simpleChanges: SimpleChanges) {
		if (
			simpleChanges
			&& (simpleChanges.isLoading && !simpleChanges.isLoading.firstChange && !simpleChanges.isLoading.currentValue) || (simpleChanges.project)
		) {
			this.calculateKpis();
			this.checkShowAllKpis();
		}
	}

	calculateKpis() {
		if (this.project && this.project.kpiCalculations) {
			this.kpis = this.project.kpiCalculations;
			this.kpis.forEach(kpi => {
				const cumulative: KPICalculationResult = this.projectKpiService.calculateKpi(kpi);
				if (cumulative) {
					kpi.finalSum = this.calculateKpiSidebar(kpi, cumulative.result);
					kpi.delta = this.calculateDelta(kpi, kpi.finalSum);
				}
			});
		}
	}

	calculateKpiSidebar(kpi: KPICalculation, finalSum: number): number {
		if (finalSum) {
			if (kpi.isPercentage) {
				finalSum *= 100;
			} else if (kpi.isMonthly) {
				const numberOfMonths: number = this.projectService.getMonthsInStatsDateRange();
				finalSum = finalSum / (numberOfMonths !== 0 ? numberOfMonths : 1);
			}
		} else {
			finalSum = 0;
		}
		return finalSum;
	}

	calculateDelta(kpi: KPICalculation, sum: number) {
		let kpiGoal = kpi.goal;
		if (kpi.isTime) {
			kpiGoal *= 1000;
		}
		if (kpi.goal) {
			const delta = (sum / kpiGoal) * 100;
			return delta;
		}
	}

	selectKPI(kpi: KPICalculation) {
		this.projectKpiService.selectKPI(kpi);
	}
}
